module.exports = __webpack_public_path__ + "static/media/GaralLogo.46eaea47.png";